import React, { Component, Fragment } from "react";
import Dialog from "../../../../libraries/Dialog";
import ExpandableTable from "./inputs/ExpandableTable";
import InputTypeNumber from "../../../SingleInputs/InputTypeNumber";
import InputTypeText from "../../../SingleInputs/InputTypeText";
import InputTypeDropdown from "../../../SingleInputs/InputTypeDropdown";
import { languageService } from "../../../../Language/language.service";
import { ToastService } from "../../../../utils/toastify";
import { CRUDFunction } from "../../../../reduxCURD/container";
import { ButtonStyle } from "../../../../style/basic/commonControls";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import { themeService } from "../../../../theme/service/activeTheme.service";
class CreateOEM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: {
        title: "",
        startEngHour: 0,
        endEngHour: 10000,
        gap: 500,
        threshold: 5,
      },
      dataToLoadForTable: {},
      testData: [],
    };
    this.updateInputValues = this.updateInputValues.bind(this);
    this.addRow = this.addRow.bind(this);
    this.HandleChangeOfValues = this.HandleChangeOfValues.bind(this);
    this.getGapOptions = this.getGapOptions.bind(this);
    this.verifyValues = this.verifyValues.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
  }

  updateInputValues(val, property, index) {
    const { testData } = this.state;
    let newState = [...testData]; // Shallow copy for better performance
    newState[index][property] = val;
    this.setState({ testData: newState });
  }

  addRow() {
    const { testData } = this.state;
    let newState = [...testData]; // Shallow copy for better performance
    newState.push({ checkItemName: "", freq: 1, startHour: 0 });
    this.setState({ testData: newState });
  }
  deleteRow(index) {
    const { testData } = this.state;
    let newState = [...testData];
    newState.splice(index, 1);
    this.setState({ testData: newState });
  }

  HandleChangeOfValues(id, value) {
    let val = value;
    if (id === "endEngHour") {
      if (value % 1000 !== 0) {
        val = Math.ceil(value / 1000) * 1000;
      }
    }
    this.setState({
      tableData: {
        ...this.state.tableData,
        [id]: id === "title" ? val : parseInt(val),
      },
    });
  }

  getGapOptions() {
    let options = [];
    const { tableData } = this.state;
    if (tableData.endEngHour) options = getOptions500(tableData.endEngHour);
    options = options.map((e) => {
      return { label: e, value: e };
    });

    return options;
  }
  verifyValues() {
    const { endEngHour, startEngHour, gap, threshold } = this.state.tableData;
    if (parseInt(endEngHour) < 0 || parseInt(startEngHour) < 0) {
      ToastService.Error("Engine hours cannot be less than 0", "");
      return;
    }
    if (parseInt(endEngHour) < parseInt(startEngHour)) {
      ToastService.Error("Starting engine hours cannot be greater than ending engine hours", "");
      return;
    }

    console.log(this.state.tableData);
    this.setState({
      dataToLoadForTable: JSON.parse(JSON.stringify(this.state.tableData)),
    });
  }

  verifyAllInputs = () => {
    const { tableData, testData } = this.state;
    let { title, startEngHour, endEngHour, gap, threshold } = tableData;
    if (title === "") {
      ToastService.Error("Title cannot be empty", "");
      return false;
    }
    if (endEngHour < 1000 || endEngHour % 1000 != 0) {
      ToastService.Error("Engine hours must be a multiple of 1000", "");
      return false;
    }
    if (threshold < 1 || threshold > 50) {
      ToastService.Error("Threshold must be between 1 and 50", "");
      return false;
    }

    if (testData.length <= 0) {
      ToastService.Error("Please configure a table first", "");
      return false;
    }
    let check = true;
    for (let e of testData) {
      const { checkItemName, freq } = e;
      let parsedFreq = typeof freq === "string" ? parseFloat(freq) : freq;
      if (checkItemName == "") {
        ToastService.Error("Test name cannot be empty", "");
        return false;
      }
      if (isNaN(parsedFreq) || parsedFreq <= 0 || !Number.isInteger(parsedFreq)) {
        ToastService.Error("Test frequency must be a positive number", "");
        return false;
      }
    }
    return check;
  };
  async handleCreate() {
    if (this.verifyAllInputs()) {
      const { createOEMPageData, oemCreated } = this.props;
      const { tableData, testData } = this.state;
      if (testData.length < 1) {
        ToastService.Error("OEM schedule table cannot be empty", "");
        return;
      }
      const finalStructure = {
        ...tableData,
        threshold: (tableData.threshold / 100) * tableData.gap,
        table: [...testData],
      };
      const applicationlookups = {
        opt2: finalStructure,
      };
      try {
        const result = await createOEMPageData(applicationlookups);
        await oemCreated(result.response);
        ToastService.Success("OEM created successfully", "");
      } catch (error) {
        ToastService.Error("Failed to create new OEM", error);
      }
      this.props.close();
    }

    // console.log("create");
  }
  render() {
    const { isOpen, close } = this.props;
    const { tableData, dataToLoadForTable } = this.state;

    return (
      <Fragment>
        <Dialog
          className={"manage-equipments-dialog"}
          title={languageService("Create OEM Maintenance")}
          isOpen={isOpen}
          body={
            <div>
              <div className="field">
                <InputTypeText
                  onChange={(v) => {
                    this.HandleChangeOfValues("title", v);
                  }}
                  label={"Title"}
                  value={tableData.title}
                />
              </div>
              <div className="field">
                <InputTypeNumber
                  onChange={(v) => {
                    this.HandleChangeOfValues("endEngHour", v);
                  }}
                  label={"Enter Ending Hours"}
                  value={tableData.endEngHour}
                  inputProps={{
                    step: 1000,
                    min: 1000,
                  }}
                />
              </div>
              <div className="field">
                <InputTypeDropdown
                  label="Gap"
                  value={tableData.gap}
                  onChange={(newValue) => {
                    this.HandleChangeOfValues("gap", newValue);
                  }}
                  options={this.getGapOptions()}
                />
              </div>
              <div className="field">
                <InputTypeNumber
                  onChange={(v) => {
                    let x = v;
                    if (v < 1) x = 1;
                    if (v > 100) x = 100;
                    this.HandleChangeOfValues("threshold", x);
                  }}
                  label={"Threshold (% Gap)"}
                  value={tableData.threshold}
                  inputProps={{
                    min: 1,
                    max: 50,
                    step: 1,
                  }}
                />
              </div>
              <MyButton type="button" style={themeService(ButtonStyle.commonButton)} onClick={this.verifyValues}>
                {languageService("Configure Table")}
              </MyButton>

              {Object.keys(this.state.dataToLoadForTable).length > 0 && (
                <ExpandableTable
                  formData={dataToLoadForTable}
                  testData={this.state.testData}
                  deleteRow={this.deleteRow}
                  updateInputValues={this.updateInputValues}
                  addRow={this.addRow}
                />
              )}
            </div>
          }
          footer={
            <div style={{ display: "flex", gap: "30px" }}>
              <MyButton
                type="button"
                style={themeService(ButtonStyle.commonButton)}
                onClick={() => {
                  this.handleCreate();
                }}
              >
                {languageService("Create")}
              </MyButton>
              <MyButton type="button" style={themeService(ButtonStyle.commonButton)} onClick={() => close()}>
                {languageService("Cancel")}
              </MyButton>
            </div>
          }
        />
      </Fragment>
    );
  }
}
let actionOptions = {
  create: true,
  update: false,
  read: false,
  delete: false,
};
const CreateOEMContainer = CRUDFunction(CreateOEM, "OEMPageData", actionOptions, null, null, "oem/create-oem");

export default CreateOEMContainer;

const getOptions500 = function (maxNum) {
  let x = [];
  for (let i = 500; i < maxNum; i += 500) {
    if (maxNum % i === 0) x.push(i);
  }
  return x;
};



// WEBPACK FOOTER //
// ./src/components/AssetView/OEM/CreateNewOEM/CreateOEM.jsx